import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../assets/styles/mixins.scss';
import tickIcon from '../../assets/images/tickIcon.svg';
import Icons from '../icons/Icon';

const useToggleStyle = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  toggleLabel: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight600,
    fontSize: mixins.fontSize14,
    lineHeight: '22px',
    color: mixins.navyColor
  },
  toggleTrack: {
    width: 52,
    height: 24,
    transition: 'background-color 0.3s, border-color 0.3s',
    display: 'flex',
    alignItems: 'center'
  },
  toggleThumb: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    transition: 'left 0.3s, background-color 0.3s',
    textAlign: 'center'
  },
  checkMark: {
    width: 16,
    height: 16,
    display: 'contents'
  },
  crossMark: {
    position: 'absolute',
    right: 10,
    width: 16,
    height: 16,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  toggleWrapper: {
    padding: 5,
    borderRadius: 20,
    position: 'relative',
    cursor: 'pointer'
  }
});

const CustomToggle = ({ label, value, onChange }) => {
  const classes = useToggleStyle();

  const trackStyle = {
    justifyContent: value ? 'flex-end' : 'space-between'
  };

  const wrapperStyle = {
    backgroundColor: value ? mixins.amethystColor : mixins.chalkWhiteFont,
    border: `1px solid ${value ? mixins.amethystColorV2 : mixins.amethystColor}`
  };

  const thumbStyle = {
    backgroundColor: value ? mixins.chalkWhiteFont : mixins.amethystColor
  };

  return (
    <div className={classes.container}>
      <Typography className={classes.toggleLabel}>{label}</Typography>
      <div className={classes.toggleWrapper} style={wrapperStyle}>
        <div
          className={classes.toggleTrack}
          style={trackStyle}
          role="switch"
          aria-checked={value}
          tabIndex={0}
          onClick={() => onChange(!value)}
          onKeyDown={(e) => {
            if (e.key === ' ' || e.key === 'Enter') {
              e.preventDefault();
              onChange(!value);
            }
          }}
        >
          {!value &&
          <span className={classes.crossMark}>
            <Icons name="CloseIcon" />
          </span>
          }
          <div className={classes.toggleThumb} style={thumbStyle}>
            {value &&
            <span className={classes.checkMark}>
              <img alt="" src={tickIcon} />
            </span>
          }
          </div>
        </div>
      </div>
    </div>
  );
};

CustomToggle.propTypes = {
  label: PropTypes.string,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

CustomToggle.defaultProps = {
  label: 'Show checkbox'
};

export default CustomToggle;
